import React from 'react'
import { dataProps } from '@ds/react-utils'
import { useThemeStyles } from '../../../theming'
import styles from './styles'

export interface InputRequiredAsteriskProps {
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
}

export function InputRequiredAsterisk(props: InputRequiredAsteriskProps) {
  const sx = useThemeStyles(styles)

  return (
    <span {...dataProps(props)} css={sx.default.asterisk} aria-hidden="true">
      *
    </span>
  )
}

InputRequiredAsterisk.displayName = 'InputRequiredAsterisk'
